export const SET_ALERT = "SET_ALERT"
export const REMOVE_ALERT = "REMOVE_ALERT"
export const REGISTER_SUCCESS = "REGISTER_SUCCESS"
export const REGISTER_FAIL = "REGISTER_FAIL"
export const USER_LOADED = "USER_LOADED"
export const AUTH_ERROR = "AUTH_ERROR"
export const LOGIN_SUCCESS = "LOGIN_SUCCESS"
export const LOGIN_FAIL = "LOGIN_FAIL"
export const LOGOUT = "LOGOUT"
export const GET_HALLS = "GET_HALLS"
export const GET_HALL = "GET_HALL"
export const HALL_ERROR = "HALL_ERROR"
export const CLEAR_HALL = "CLEAR_HALL"
export const GET_MY_BOOKINGS = "GET_MY_BOOKINGS"
export const BOOKING_ERROR = "BOOKING_ERROR"
export const BOOKING_SUCCESS = "BOOKING_SUCCESS"
export const BOOKING_FAILURE = "BOOKING_FAILURE"
export const DELETE_BOOKING = "DELETE_BOOKING"
